import React from 'react';
import './SelectOffer.scss';

function SelectOffer(props) {
  const {
    offerCategory,
    selectOffer,
    defaultCategory,
    dataLocale: { SKIP },
  } = props;
  return (
    <React.Fragment>
      <div className="offer-list mr-t20">
        {offerCategory &&
          offerCategory.map((offer, index) => {
            const { offer_text, cat_banner } = offer;
            return (
              <div key={index} className="item pos-rel">
                <input
                  className="pos-abs"
                  id={`offer-${index}`}
                  name="offer"
                  style={{ visibility: 'hidden' }}
                  type="radio"
                />
                <label key={index} htmlFor={`offer-${index}`} onClick={() => selectOffer(offer)}>
                  <img alt={offer_text} className="cursor-pointer" src={cat_banner} />
                </label>
              </div>
            );
          })}
      </div>
      <div className="text-center pd-t20 pd-b10 clearfix">
        <div
          className="cursor-pointer skip-cta text-uppercase fsp13 fs13 fw500 color_pale_black"
          onClick={() => selectOffer(defaultCategory)}
        >
          {SKIP}
        </div>
      </div>
    </React.Fragment>
  );
}

export default SelectOffer;
